import { render, staticRenderFns } from "./confirmDispatch.vue?vue&type=template&id=3c7f4a0e&"
import script from "./confirmDispatch.vue?vue&type=script&lang=js&"
export * from "./confirmDispatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports